import gql from "graphql-tag";

const CREATE_PRODUCT = gql`
  mutation createProduct($productInput: ProductInput!) {
    createProduct(productInput: $productInput)
  }
`;

export default CREATE_PRODUCT;
